import React from "react";
import {
  Datagrid,
  TextField,
  ShowButton,
  EditButton,
  useTranslate,
  FunctionField,
} from "react-admin";
import { JsonField } from "react-admin-json-view";
import {
  DateField,
  CreateOnlyTopToolbar,
  CustomList,
  EmptyMessage,
} from "../../../shared/components/index.js";
import ClientFilter from "../ClientFilter.js";

const ListClient = (props) => {
  const t = useTranslate();

  return (
    <CustomList
      filters={<ClientFilter {...props} />}
      actions={<CreateOnlyTopToolbar />}
    >
      <Datagrid
        empty={<EmptyMessage />}
        rowClick={false}
        bulkActionButtons={false}
      >
        <TextField source="phone" />
        <TextField source="email" />
        <TextField source="first_name" />
        <TextField source="last_name" />
        <FunctionField
          source="entity"
          sortable={false}
          render={(record) => {
            if (record.entity === 1) {
              return t("resources.Client.source.entity.physical");
            }

            if (record.entity === 2) {
              return t("resources.Client.source.entity.legal");
            }
          }}
        />
        <FunctionField
          source="status"
          render={(record) =>
            t(`resources.Client.source.status.${record.status}`)
          }
        />
        <JsonField
          reference="Changes"
          source="unconfirmed_changes"
          label="resources.Client.fields.unconfirmed_changes.name"
          reactJsonOptions={{
            name: null,
            collapsed: true,
            enableClipboard: false,
            displayDataTypes: false,
          }}
          sortable={false}
        />
        <DateField source="created_at" />
        <DateField source="updated_at" />
        <FunctionField
          source="deleted_at"
          render={(record) => {
            if (record && record.deleted_at) {
              return <DateField source="deleted_at" />;
            } else {
              return t("");
            }
          }}
          label="resources.Client.source.deleted"
        />
        <ShowButton className="button-show" />
        <EditButton className="button-edit" />
      </Datagrid>
    </CustomList>
  );
};

export default ListClient;
